"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const fmko_ts_common_1 = require("fmko-ts-common");
const WCAGNumberField_1 = tslib_1.__importDefault(require("./WCAGNumberField"));
const TimeUnitDropdown_1 = tslib_1.__importStar(require("./TimeUnitDropdown"));
const FieldSize_1 = require("../types/FieldSize");
class TimeInDaysWeeksMonth extends fmko_ts_common_1.Widget {
    constructor(timeInDaysWeeksMonthsArgs) {
        super();
        this.handlerManager = new fmko_ts_common_1.HandlerManager();
        this.oldValue = null;
        const { numberLabel, numberHint, dropdownLabel } = timeInDaysWeeksMonthsArgs;
        this.numberField = new WCAGNumberField_1.default({
            fieldSizeClass: FieldSize_1.FieldSize.S,
            hint: numberHint,
            label: numberLabel
        });
        this.numberField.allowNegative = false;
        this.numberField.addValueChangeHandler(() => {
            this.setValue(this.getValue(), true);
        });
        // Right-anchored so the dropdown list element lines up with the border (would be 1 pixel off if dropdown was left-anchored-element)
        this.numberField.getFieldElement().classList.add("right-anchored-element");
        this.timeUnitDropdown = new TimeUnitDropdown_1.default({
            label: dropdownLabel,
            noOptionText: null,
            shouldSelectIfSingleOption: false
        });
        this.timeUnitDropdown.addValueChangeHandler(() => {
            this.setValue(this.getValue(), true);
        });
        this.element = document.createElement("div");
        this.element.classList.add("flex-row");
        this.element.appendChild(this.numberField.element);
        this.element.appendChild(this.timeUnitDropdown.element);
    }
    getOffsetDatesInclusive(base) {
        if (!base) {
            return null;
        }
        let result = null;
        const value = this.numberField.getValue();
        if (!value) {
            return null;
        }
        const selected = this.timeUnitDropdown.getValue();
        const baseDateInclusive = fmko_ts_common_1.LuxonDateTime
            .fromJSDate(base)
            .minus({ day: 1 });
        if (TimeUnitDropdown_1.TimeUnitDropdownEnum.DAYS === selected) {
            result = baseDateInclusive.plus({
                days: value
            }).toJSDate();
        }
        else if (TimeUnitDropdown_1.TimeUnitDropdownEnum.WEEKS === selected) {
            result = baseDateInclusive.plus({
                weeks: value
            }).toJSDate();
        }
        else if (TimeUnitDropdown_1.TimeUnitDropdownEnum.MONTHS === selected) {
            result = baseDateInclusive.plus({
                months: value
            }).toJSDate();
        }
        return result;
    }
    setOffsetDatesInclusive(base, end) {
        const duration = fmko_ts_common_1.DateUtil.daysBetween(base, end);
        this.timeUnitDropdown.setValue(this.timeUnitDropdown.getOptions()[0]);
        this.numberField.setValue(duration);
    }
    getIntervalField() {
        return this.numberField;
    }
    getDropdown() {
        return this.timeUnitDropdown;
    }
    getValue() {
        const selected = this.timeUnitDropdown.getValue();
        const value = this.numberField.getValue();
        if (!value) {
            return null;
        }
        return { unit: selected, value };
    }
    setValue(value, fireEvents = false) {
        if (!value) {
            this.numberField.setValue(null);
            if (fireEvents && this.oldValue != null) {
                this.oldValue = value;
                fmko_ts_common_1.ValueChangeEvent.fire(this, value);
            }
        }
        else if (value !== this.oldValue) {
            this.numberField.setValue(value.value);
            this.timeUnitDropdown.setValue(value.unit);
            if (fireEvents) {
                this.oldValue = value;
                fmko_ts_common_1.ValueChangeEvent.fire(this, value);
            }
        }
    }
    clearValue(fireEvents = false) {
        this.numberField.clearValue();
        this.timeUnitDropdown.clearValue();
        if (fireEvents) {
            this.oldValue = this.getValue();
            fmko_ts_common_1.ValueChangeEvent.fire(this, this.oldValue);
        }
    }
    setEnabled(enabled) {
        this.timeUnitDropdown.setEnabled(enabled);
        this.numberField.setEnabled(enabled);
    }
    isEnabled() {
        return this.timeUnitDropdown.isEnabled() && this.numberField.isEnabled();
    }
    fireEvent(event) {
        this.handlerManager.fireEvent(event);
    }
    addValueChangeHandler(handler) {
        if (!this.valueChangeHandlerInitialized) {
            this.valueChangeHandlerInitialized = true;
            this.numberField.addValueChangeHandler(() => fmko_ts_common_1.ValueChangeEvent.fire(this, this.getValue()));
            this.timeUnitDropdown.addValueChangeHandler(() => fmko_ts_common_1.ValueChangeEvent.fire(this, this.getValue()));
        }
        return this.handlerManager.addHandler(handler);
    }
}
exports.default = TimeInDaysWeeksMonth;
//# sourceMappingURL=TimeInDaysWeeksMonth.js.map